import React, {useEffect, useState} from "react";
import axios from "axios";

const PerformanceTable = ({items}) => {

  const symbols = ['EAT.WAR', 'WIG.INDX', 'EAT.MC', 'IBEX.INDX']; //['EAT.WAR', 'WIG.INDX'];

  const [data, setData] = useState([]);

  useEffect(() => {
    if (data.length === 0) {
      getData();
    }
  });

  function getData() {
    let requests = [];
    let respData = [];
    const language = drupalSettings.path.currentLanguage || '';

    symbols.forEach(symbol => requests.push(axios.get(`/` + language + `/api/market/${symbol}/performance`)));

    axios.all(requests).then(axios.spread((...responses) => {
      responses.forEach(resp => {
        respData.push(resp.data);
      });
      setData(respData);
    })).catch(errors => {
    });
  }

  return (
    <>
      <div>
        <table className="table table-stripped">
          <thead>
          <tr>
            <th className="pl-4 align-middle">{Drupal.t("Instrument", null, {context: 'Stock'})}</th>
            <th className="text-center align-middle">{Drupal.t("1M change")}&nbsp;(%)</th>
            <th className="text-center align-middle">{Drupal.t("3M change")}&nbsp;(%)</th>
            <th className="text-center align-middle">{Drupal.t("1Yr change")}&nbsp;(%)</th>
            <th className="text-center align-middle">{Drupal.t("3 years change")}&nbsp;(%)</th>
            <th className="text-center align-middle">{Drupal.t("1Yr high & low")}</th>
          </tr>
          </thead>
          <tbody>
          {data.map((row, index) => {
            return (<tr key={index}>
              <td className="pl-4 font-weight-bold align-middle">{symbols[index]}</td>
              <td className="align-middle text-center">{createChangeStyle(row["1M"])}</td>
              <td className="align-middle text-center">{createChangeStyle(row["3M"])}</td>
              <td className="align-middle text-center">{createChangeStyle(row["52W"])}</td>
              <td className="align-middle text-center">{createChangeStyle(row["3Y"])}</td>
              <td className="high-low align-middle text-muted text-center">
                <div className="d-inline-block text-left">
                  <span className="high d-block">H: {thousendMe((parseFloat(row["HL52W"].high).toFixed(2)))}</span>
                  <span className="low d-block">L: {thousendMe((parseFloat(row["HL52W"].low)).toFixed(2))}</span>
                </div>
              </td>
            </tr>)
          })}
          </tbody>
        </table>
      </div>
    </>
  );
};

function thousendMe(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function createChangeStyle(number) {
  number = (parseFloat(number)*100).toFixed(2)

  const plusStyle = <div className="d-inline-block text-success change">
    <i className="fas fa-sort-up pr-1"></i><span>{number}</span></div>;
  const minusStyle = <div className="d-inline-block text-danger change">
    <i className="fas fa-sort-down pr-1"></i><span>{number}</span></div>;
  const zeroStyle = <div className="d-inline-block text-muted change"><span>{number}</span></div>;

  if (number > 0) return plusStyle;
  if (number === 0) return zeroStyle;
  if (number < 0) return minusStyle;
}

export default PerformanceTable;
